module.exports = __webpack_public_path__ + "static/img/pic_rjyf_rjfw_yw_pre.bc6c0753.png";